import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  backNavTitle = new BehaviorSubject<string>('');
  backNavUrl = new BehaviorSubject<string>('');

  constructor() {}

  /**
   * Sets the top level navigation for loan form.
   *
   * Use the constructor to set this state.
   *
   * @param backNavTitle Title of page to navigate back to.
   * @param backNavUrl Url for the page to navigate back to.
   */
  setBackNav(backNavTitle: string, backNavUrl: string) {
    this.backNavTitle.next(backNavTitle);
    this.backNavUrl.next(backNavUrl);
  }
}
